export function toMinutes(hour) {
    return hour * 60;
}
